/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Record_DistanceInputs */

const en_us2_workout_live_record_distance = /** @type {(inputs: Workout_Live_Record_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longest distance in a set`)
};

const pt_br2_workout_live_record_distance = /** @type {(inputs: Workout_Live_Record_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior distância numa série`)
};

const es_419_workout_live_record_distance = /** @type {(inputs: Workout_Live_Record_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mayor distancia en una serie`)
};

const pt_pt2_workout_live_record_distance = /** @type {(inputs: Workout_Live_Record_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior distância numa série`)
};

const fr_fr2_workout_live_record_distance = /** @type {(inputs: Workout_Live_Record_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus longue distance en une série`)
};

const de_de2_workout_live_record_distance = /** @type {(inputs: Workout_Live_Record_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Längste Distanz in einem Satz`)
};

const it_it2_workout_live_record_distance = /** @type {(inputs: Workout_Live_Record_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distanza più lunga in una serie`)
};

/**
* | output |
* | --- |
* | "Longest distance in a set" |
*
* @param {Workout_Live_Record_DistanceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_record_distance = /** @type {((inputs?: Workout_Live_Record_DistanceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Record_DistanceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_record_distance(inputs)
	if (locale === "es-419") return es_419_workout_live_record_distance(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_record_distance(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_record_distance(inputs)
	if (locale === "de-DE") return de_de2_workout_live_record_distance(inputs)
	if (locale === "it-IT") return it_it2_workout_live_record_distance(inputs)
	return en_us2_workout_live_record_distance(inputs)
});
export { workout_live_record_distance as "workout-live.record_distance" }